import { injectable } from "inversify";
import { ApiPage } from "@/core/models/page.model";
import { TableRepo } from "../table.repo";
import { CategoryArticleModel } from "@/core/models/category-article.model";

interface CategoryArticleGetParams {
    search?: string;
}

@injectable()
export class CategoryArticleRepo extends TableRepo<CategoryArticleModel> {
    constructor() {
        super("/api/CategoryArticle");
    }

    async getData(
        index: number,
        params: CategoryArticleGetParams,
        pageSize = 10
    ): Promise<ApiPage<CategoryArticleModel> | null> {
        return await super.getData(index, params, pageSize);
    }
}
